export default {
    wizardType: "LINKEDINADS",

    getConnectionParams: (type, model) => ({
        ClientId: model.get("clientId"),
        ClientSecret: model.get("clientSecret"),
        AccessToken: model.get("accessToken"),
        RefreshToken: model.get("refreshToken"),
        AutoTokenRenewal: model.get("autoTokenRenewal"),
    }),
};

